// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3bsEb","inputWrap":"Table_inputWrap__kpCAo","col":"Table_col__YMnDc","bmiTooltip":"Table_bmiTooltip__3i-E6"};